import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SecondaryNavBlockListModule } from '../../shared/secondary-nav-block-list';
import { LinksModule } from '../../shared/ui/links';
import {
  SecondaryNavBlockListContainerComponent,
  secondaryNavBlockListContainerResolver,
} from './secondary-nav-block-list-container.component';

const MODULES = [CommonModule, SecondaryNavBlockListModule, LinksModule];

const DECLARATIONS = [SecondaryNavBlockListContainerComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class SecondaryNavBlockListContainerModule {
  static entry = SecondaryNavBlockListContainerComponent;
  static componentDataResolver = secondaryNavBlockListContainerResolver;
}
